import Service from '@ember/service';
export default class HeadData extends Service {}